module.exports = __webpack_public_path__ + "img/companyint.3020a27b.png";